import * as React from 'react';
import * as ReactDOM from 'react-dom';
import CircularProgress from 'material-ui/CircularProgress';
import { format } from 'date-fns';
import { Day } from './day';
import { Week } from './week';
import { Month } from './month';
import { App } from '../interfaces';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/operator/debounceTime';
import { DateTime } from 'luxon';

export type ScheduleMode = "auto" | "cal" | "list";

export interface ScheduleProps {
  controller: App.Schedule.CalendarController;
  currentMoment?: DateTime;
  mode?: ScheduleMode;

};

export interface ScheduleState {
  currentMoment: DateTime;
  currentMode: ScheduleCurrentDisplayMode;
  loading: Boolean;
};


export enum ScheduleCurrentDisplayMode {
  calendar = 1,
  list = 2
}

export class Schedule extends React.Component<ScheduleProps, ScheduleState> {

  static defaultProps = {
    mode: 'auto' as ScheduleMode
  };

  state = {
    currentMoment: this.props.currentMoment || DateTime.local(),
    currentMode: ScheduleCurrentDisplayMode.calendar,
    loading: true
  };

  private scheduleEl: HTMLDivElement;

  private resize = new Subject<UIEvent>();

  private onResize = this.resize.debounceTime(300).subscribe((e) => this.setDisplayMode());

  private momentSub: Subscription;
  private loadingSub: Subscription;

  componentWillMount() {

    this.momentSub = this.props.controller.currentMoment.subscribe(
      (currentMoment) => this.setState( { currentMoment })
    );

    this.loadingSub = this.props.controller.loading.subscribe(
      (loading) => {
        this.setState( { loading });
      }
    );

  }

   componentDidMount() {

    if (this.props.mode === 'auto') {

      window.addEventListener('resize', e => this.resize.next(e));

      this.setDisplayMode();

    } else {

      switch (this.props.mode) {
        case 'cal':

          this.setState( { currentMode: ScheduleCurrentDisplayMode.calendar } );

        break;
        case 'list':

          this.setState( { currentMode: ScheduleCurrentDisplayMode.list } );

        break;
      }

    }

  }

  componentDidWillUnmount() {

    if (this.onResize) { this.onResize.unsubscribe(); }

    if (this.momentSub) { this.momentSub.unsubscribe(); }

    if (this.loadingSub) { this.loadingSub.unsubscribe(); }

  }

  setDisplayMode() {

    const schedule = ReactDOM.findDOMNode(this.scheduleEl) as Element;

    if (schedule.clientWidth) {

      if ( (schedule.clientWidth < 480) && this.state.currentMode === ScheduleCurrentDisplayMode.calendar ) {
  
        this.setState( { currentMode: ScheduleCurrentDisplayMode.list });
  
      } else if ((schedule.clientWidth > 480) && this.state.currentMode === ScheduleCurrentDisplayMode.list) {
  
        this.setState( { currentMode: ScheduleCurrentDisplayMode.calendar });
  
      }
      
    }

  }

  render() {

    if (!this.state.currentMoment) { return null; }

    let displayModeClass;

    switch (this.state.currentMode) {

      case ScheduleCurrentDisplayMode.calendar:

        displayModeClass = 'schedule__mode--calendar';

      break;
      case ScheduleCurrentDisplayMode.list:

        displayModeClass = 'schedule__mode--list';

      break;

    }

    return (

        <div className={'schedule' + ' ' + displayModeClass } ref={(el) => { this.scheduleEl = el; }}>

          <div className={'schedule__header'}>

            <div className={'schedule__loading-indicator'}><CircularProgress style={ { visibility: !this.state.loading ? 'hidden' : 'visible'} } size={16} thickness={2} color="white" /></div>

            <div className={'schedule__month-name'}>{ this.state.currentMoment.toFormat(this.props.controller.config.monthFormat)}</div>

            <div className={'schedule__nav'}>

              <div className={'schedule__nav-item'}><button className={'schedule__nav-button'} onClick={e => this.props.controller.prevMonth()}>&larr;</button></div>

              <div className={'schedule__nav-item'}><button className={'schedule__nav-button'} onClick={e => this.props.controller.nextMonth()}>&rarr;</button></div>

            </div>

          </div>

          <Month moment={this.state.currentMoment} controller={this.props.controller}></Month>

        </div>);

  }

}


// WEBPACK FOOTER //
// ./resources/src/components/schedule/schedule.tsx